<template>
  <modal
    :width="'540px'"
    :isShow.sync="refreshDialog"
    title="刷新提示"
    :isShowBtn="[true,true]"
    :btnText="['取消','确定']"
    @clickHandler="ClickHandler"
  >
    <div class="content">
      <div class="dialog-conter">是否确认对选定的直播进行刷新？</div>
      <div class="base-table-table">
        <el-table
          ref="tableRef"
          :data="dataList"
          height="250"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="65">
          </el-table-column>
          <el-table-column
            prop="externalId"
            label="直播ID"
          >
          </el-table-column>
          <el-table-column
            prop="contentName"
            label="标题"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="createUser"
            width="100"
            label="主讲人"
          >
          </el-table-column>
          <el-table-column
            prop="liveMark"
            label="直播形式">
            <template slot-scope="scope">
              <span v-if="scope.row.liveMark === 1">正式</span>
              <span v-else>测试</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from '@/components/modal'

export default {
  name: "refreshModal",
  data() {
    return {
      refreshDialog: false,
      dataList: [],
      selectionList: []
    }
  },
  methods: {
    ClickHandler(type) {
      if(type==='one') {
        this.refreshDialog=false
      } else if(type==='two') {
        if (!this.selectionList.length) return
        this.$emit('handleRefresh')
        this.refreshDialog = false
      }
    },
    handleSelectionChange(selections) {
      this.selectionList = selections.map(item=>item.contentId)
    },
    toggleAllSelection() { // 全部选中
      this.dataList.length && this.$refs.tableRef.toggleAllSelection()
    }
  },
  components: {
    modal
  }
}
</script>

<style scoped>
.dialog-conter {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0 ;
  text-align: center;
  font-weight: 600
}
</style>
